import { LoginPage } from '../../pages/Login';
import Login from '../../pages/Login/Login';
import LoginFailed from '../../pages/Login/LoginFailed';
import Root from '../../pages/Root';
import ErrorMain from '../../pages/Error/ErrorMain';
import RefreshFailed from '../../pages/Login/RefreshFailed';
import MainLayout from '../../layouts/MainLayout/MainLayout';
import ComponentsShowcase from '../../pages/ComponentsShowcase/ComponentsShowcase';
import { Home } from '../../pages/Home/Home';
import { LoginSuccess } from '../../pages/Login/LoginSuccess';
import Profile from '../../pages/Profile';
import { ProtectedRoute } from '../../common/components/ProtectedRoute';
import { ProfilePreferences } from '../../pages/ProfilePreferences';
import ENO1Upload from '../../pages/eNO1/eNO1 upload/eNO1Upload';
import ENO1Message from '../../pages/eNO1/eNO1-message/eNO1Message';
import ENO1ViewSamples from '../../pages/eNO1/eNO1-message/ViewSamples';
import ENO1ViewStratum from '../../pages/eNO1/eNO1-message/ViewStratum';
import E55Upload from '../../pages/e55/e55-upload/e55Upload';
import E55Message from '../../pages/e55/e55-message/e55Message';
import E55ViewSamples from '../../pages/e55/e55-message/ViewSamples';
import E53Upload from '../../pages/e53/e53-upload/e53Upload';
import E53Message from '../../pages/e53/e53-message/e53Message';
import E53ViewSamples from '../../pages/e53/e53-message/ViewSamples';
import E09Message from '../../pages/e09/e09-message/e09Message';
import E09ViewSamples from '../../pages/e09/e09-message/ViewSamples';
import E09Upload from '@/pages/e09/e09-upload';
import E53ViewStratum from '../../pages/e53/e53-message/ViewStratum';
import ENO1Status from '../../pages/eNO1/eNO1-status/eNO1Status';
import NO2Report from '../../pages/eNO1/NO2Report/NO2Report';
import NO3Report from '../../pages/eNO1/NO3Report/NO3Report';
import CN54Report from '@/pages/e53/CN54/CN54';
import CN10Report from '@/pages/e09/CN10/CN10Report';
import CN56Report from '@/pages/e55/CN56/CN56Report';
import CN19Report from '@/pages/e09/CN19/CN19Report';
import E53Status from '@/pages/e53/e53-status/e53Status';
import SamplingSettings from '@/pages/SamplingPlanning/sampling-settings/SamplingSettings';
import ENO1TempOverview from '@/pages/SamplingPlanning/ENO1TempOverview/ENO1TempOverview';
import ENO1TempUpload from '@/pages/SamplingPlanning/ENO1TempUpload/ENO1TempUpload';
import E55Comparison from '@/pages/eNO1/E55Comparison/E55Comparison';
import ForecastStratum from '@/pages/SamplingPlanning/ForecastStratum/ForecastStratum';
import NO3SignedForms from '@/pages/eNO1/NO3SignedForms/NO3SignedForms';
import ItemsKgReport from '@/pages/e55/ItemsKgReport/ItemsKgReport';
import AccuracyReport from '@/pages/eNO1/AccuracyReport/AccuracyReport';
import E55Status from '@/pages/e55/e55Status/e55Status';
import E09Status from '@/pages/e09/e09Status/e09Status';
import IpcTdAccounting from '@/pages/IpcTdAccounting/NO3CN56Summary/No3Cn56Summary';
import Help from '@/pages/Help';
import HelpImport from '@/pages/Help/import/HelpImport';
import { UserRoles } from '@/common/constants/userConstants';
import RemunerationGroups from '@/pages/IpcTdAccounting/RemunerationGroups/RemunerationGroups';
import EditRemunerationGroups from '@/pages/IpcTdAccounting/RemunerationGroups/EditRemunerationGroups';
import NO4Report from '@/pages/IpcTdAccounting/NO4Report';
import UpuTdAccountingRemunerationGroups from '@/pages/UpuTdAccounting/RemunerationGroups/RemunerationGroups';
import UpuTdAccountingEditRemunerationGroups from '@/pages/UpuTdAccounting/RemunerationGroups/EditRemunerationGroups';
import Cn54bisCn56Summary from '@/pages/UpuTdAccounting/CN54bisCN56/Cn54bisCn56Summary';
import CN61CompoundRateReports from '@/pages/IpcTdAccounting/CN61CompoundRateReports/CN61CompoundRateReports';
import CN61CrrPage from '@/pages/IpcTdAccounting/CN61CompoundRateReports/CN61CrrPage';
import CN61ReimsPage from '@/pages/IpcTdAccounting/CN61CompoundRateReports/CN61ReimsPage';
import CN54bisReport from '@/pages/UpuTdAccounting/CN54bis/CN54bisReport';
import ENO1TempViewSamples from '@/pages/SamplingPlanning/ENO1TempOverview/ViewSamples';
import CN61UpuPage from '@/pages/UpuTdAccounting/CN61CompoundRateReports/CN61CompoundRateReports';
import Cn61UpuTablePage from "@/pages/UpuTdAccounting/CN61CompoundRateReports/CN61UpuPage"
import Cn61UpuCrrPage from "@/pages/UpuTdAccounting/CN61CompoundRateReports/CN61CrrPage"

const routes = [
  {
    path: '/',  
    element: <Root />,
    errorElement: <ErrorMain />,
    children: [
      {
        path: '',
        element: <MainLayout />,
        children: [
          {
            index: true,
            element: <LoginPage />,
          },
          {
            path: 'components',
            element: <ComponentsShowcase />,
          },
          {
            path: 'dashboard',
            element: <ProtectedRoute><div>Dashboard Page</div></ProtectedRoute>,
          },
          {
            path: 'import',
            element: <ProtectedRoute allowedRoles={['ADMIN', 'SUPER_USER']}><div>Import Page</div></ProtectedRoute>,
          },
          {
            path: 'export',
            element: <ProtectedRoute allowedRoles={['ADMIN', 'SUPER_USER']}><div>Export Page</div></ProtectedRoute>,
          },
          {
            path: 'help',
            element: <ProtectedRoute><Help /></ProtectedRoute>,
          },
          {
            path: 'help/import',
            element: (
              <ProtectedRoute allowedRoles={[UserRoles.ADMIN, UserRoles.SUPER_USER]}>
                <HelpImport />
              </ProtectedRoute>
            ),
          },
          {
            path: '/sso-login',
            element: <Login />,
          },
          {
            path: '/login-failed',
            element: <LoginFailed />,
          },
          {
            path: '/refresh-failed',
            element: <RefreshFailed />,
          },
          {
            path: 'home',
            element: <ProtectedRoute><Home /></ProtectedRoute>,
          },
          {
            path: 'login-success',
            element: <LoginSuccess />,
          },
          {
            path: 'settings',
            element: <ProtectedRoute><Profile /></ProtectedRoute>,
          },
          {
            path: 'profile',
            element: <ProtectedRoute><ProfilePreferences /></ProtectedRoute>,
          },
          {
            path: 'eno1/upload',
            element: <ProtectedRoute><ENO1Upload /></ProtectedRoute>,
          },
          {
            path: 'eno1/messages/samples/:fileId',
            element: <ProtectedRoute><ENO1ViewSamples /></ProtectedRoute>,
          },
          {
            path: 'eno1/messages/stratum/:fileId',
            element: <ProtectedRoute><ENO1ViewStratum /></ProtectedRoute>,
          },
          {
            path: 'eno1/status',
            element: <ProtectedRoute><ENO1Status /></ProtectedRoute>,
          },
          {
            path: 'eno1',
            element: <ProtectedRoute><ENO1Message /></ProtectedRoute>,
          },
          {
            path: 'eno1/reports/no2',
            element: <ProtectedRoute><NO2Report /></ProtectedRoute>,
          },
          {
            path: 'eno1/reports/no3',
            element: <ProtectedRoute><NO3Report /></ProtectedRoute>,
          },
          {
            path: 'eno1/reports/no3/signed',
            element: <ProtectedRoute><NO3SignedForms /></ProtectedRoute>,
          },
          {
            path: 'eno1/reports/accuracy',
            element: <ProtectedRoute><AccuracyReport /></ProtectedRoute>,
          },
          {
            path: 'e55/upload',
            element: <ProtectedRoute><E55Upload /></ProtectedRoute>,
          },
          {
            path: 'e55/despatches',
            element: <ProtectedRoute><E55Message /></ProtectedRoute>,
          },
          {
            path: 'e55/despatches/:fileId',
            element: <ProtectedRoute><E55ViewSamples /></ProtectedRoute>,
          },
          {
            path: 'e55/reports/cn56',
            element: <ProtectedRoute><CN56Report /></ProtectedRoute>,
          },
          {
            path: 'e55/reports/items-kg',
            element: <ProtectedRoute><ItemsKgReport /></ProtectedRoute>,
          },
          {
            path: 'e55/status',
            element: <ProtectedRoute><E55Status /></ProtectedRoute>,
          },
          {
            path: 'e53/upload',
            element: <ProtectedRoute><E53Upload /></ProtectedRoute>,
          },
          {
            path: 'e53',
            element: <ProtectedRoute><E53Message /></ProtectedRoute>,
          },
          {
            path: 'e53/samples/:fileId',
            element: <ProtectedRoute><E53ViewSamples /></ProtectedRoute>,
          },
          {
            path: 'e53/messages/stratum/:fileId',
            element: <ProtectedRoute><E53ViewStratum /></ProtectedRoute>,
          },
          {
            path: 'e53/reports/cn54',
            element: <ProtectedRoute><CN54Report /></ProtectedRoute>,
          },
          {
            path: 'e53/status',
            element: <ProtectedRoute><E53Status /></ProtectedRoute>,
          },
          {
            path: 'e09/upload',
            element: <ProtectedRoute><E09Upload /></ProtectedRoute>,
          },
          {
            path: 'e09/despatches',
            element: <ProtectedRoute><E09Message /></ProtectedRoute>,
          },
          {
            path: 'e09/despatches/:fileId',
            element: <ProtectedRoute><E09ViewSamples /></ProtectedRoute>,
          },
          {
            path: 'e09/reports/cn10',
            element: <ProtectedRoute><CN10Report /></ProtectedRoute>,
          },
          {
            path: 'e09/reports/cn19',
            element: <ProtectedRoute><CN19Report /></ProtectedRoute>,
          },
          {
            path: 'e09/status',
            element: <ProtectedRoute><E09Status /></ProtectedRoute>,
          },
          {
            path: 'sampling-settings',
            element: <ProtectedRoute><SamplingSettings /></ProtectedRoute>,
          },
          {
            path: 'stratum-sizes-sampling_rates',
            element: <ProtectedRoute><ForecastStratum /></ProtectedRoute>,
          },
          {
            path: 'eno1-temp-overview',
            element: <ProtectedRoute><ENO1TempOverview /></ProtectedRoute>,
          },
          {
            path: 'eno1-temp-upload',
            element: <ProtectedRoute><ENO1TempUpload /></ProtectedRoute>,
          },
          {
            path: 'eno1/reports/e55-comparison',
            element: <ProtectedRoute><E55Comparison /></ProtectedRoute>,
          },
          {
            path: 'no3-cn56-summary',
            element: <ProtectedRoute><IpcTdAccounting /></ProtectedRoute>,
          },
          {
            path: 'remuneration-groups',
            element: <ProtectedRoute><RemunerationGroups /></ProtectedRoute>,
          },
          {
            path: 'remuneration-groups/edit',
            element: <ProtectedRoute><EditRemunerationGroups /></ProtectedRoute>,
          },
          {
            path: '/upu-remuneration-groups',
            element: <ProtectedRoute><UpuTdAccountingRemunerationGroups /></ProtectedRoute>,
          },
          {
            path: '/upu-remuneration-groups/edit',
            element: <ProtectedRoute><UpuTdAccountingEditRemunerationGroups /></ProtectedRoute>,
          },
          {
            path: 'no4-report',
            element: <ProtectedRoute><NO4Report /></ProtectedRoute>,
          },
          {
            path: 'cn54bis-cn56-summary',
            element: <ProtectedRoute><Cn54bisCn56Summary /></ProtectedRoute>,
          },
          {
            path: 'cn61-crr',
            element: <ProtectedRoute><CN61CompoundRateReports /></ProtectedRoute>,
          },
          {
            path: 'cn61-compound-rate-reports/crr',
            element: <ProtectedRoute><CN61CrrPage /></ProtectedRoute>,
          },
          {
            path: 'cn61-compound-rate-reports/reims',
            element: <ProtectedRoute><CN61ReimsPage /></ProtectedRoute>,
          },
          {
            path: 'cn54bis-report',
            element: <ProtectedRoute><CN54bisReport /></ProtectedRoute>,
          },
          {
            path: 'sampling-planning/temp-samples/eno1/:fileId',
            element: <ProtectedRoute><ENO1TempViewSamples /></ProtectedRoute>,
          },
          {
            path: 'upu-cn61-crr',
            element: <ProtectedRoute><CN61UpuPage /></ProtectedRoute>,
          },
          {
            path: 'cn61-compound-rate-reports/upu',
            element: <ProtectedRoute><Cn61UpuTablePage /></ProtectedRoute>,
          },
          {
            path: 'cn61-compound-rate-reports/upu/crr',
            element: <ProtectedRoute><Cn61UpuCrrPage /></ProtectedRoute>,
          },
        ],
      },
    ],
  },
  
];

export default routes;
